import { render, staticRenderFns } from "./Titlebar.vue?vue&type=template&id=6a69ac9d&scoped=true&"
import script from "./Titlebar.vue?vue&type=script&lang=js&"
export * from "./Titlebar.vue?vue&type=script&lang=js&"
import style0 from "./Titlebar.vue?vue&type=style&index=0&id=6a69ac9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a69ac9d",
  null
  
)

export default component.exports